"use strict";

const MuniOpenChannelDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareMuniOpenChannel,
        template: "list/muniOpenChannelsDataList.njk",
        layerName: "muniOpenChannel",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("open-channel-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "open-channels");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
  };

  var initialRender = function () {
    DataList.setSorting("name", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareMuniOpenChannel = function (muniOpenChannels) {
    for (const openChannel of muniOpenChannels) {
      openChannel.lastInspectionDate = openChannel.routine[openChannel.routine.length - 1];
      openChannel.lastInspectionDisplayDate = openChannel.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(openChannel.lastInspectionDate)
        : null;
    }
    sortMuniOpenChannelsBy(muniOpenChannels);

    return {
      rows: muniOpenChannels,
      options: {},
    };
  };

  var sortMuniOpenChannelsBy = function (muniOpenChannels) {
    const alphaSorter = SortUtilities.alphaSorter;

    var sortersDict = {
      name: alphaSorter,
      lineServiceType: alphaSorter,
      openChannelType: alphaSorter,
      material: alphaSorter,
      cof: SortUtilities.cofSorter,
      lastInspectionDate: DateTime.dateComparator,
    };
    DataList.sortWithDict(muniOpenChannels, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniOpenChannelDataListController();

const DataList = require("../mapFunctions/dataList");
const SortUtilities = require("../general/sortUtilities.js");
const MapFunctions = require("../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../routes/urlRoutes");
const Analytics = require("../general/analytics");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const DateTime = require("../dateTime");
